import { useLocation } from "react-router-dom";

export const NotFound = () => {
  const location = useLocation();
  console.error("404 page not found:", location.pathname);

  return (
    <div className="flex flex-col items-center justify-center h-screen p-4">
      <h1 className="text-5xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-gray-600 mb-6">Page not found: {location.pathname}</p>
      <a
        href="/"
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
      >
        Go Home
      </a>
    </div>
  );
};
